import React, { Component } from 'react';
import {Switch, Route} from 'react-router-dom'
import classnames from 'classnames';
import {Card, CardTitle, CardText} from 'material-ui/Card';
import {GridList, GridTile} from 'material-ui/GridList';
import {List, ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import {Tabs, Tab} from 'material-ui/Tabs';

import Phone from 'material-ui/svg-icons/communication/phone';
import Mail from 'material-ui/svg-icons/communication/email';
import Address from 'material-ui/svg-icons/communication/business';

class Page extends Component {
  constructor(props) {
    super(props);

    this.changeTab = this.changeTab.bind(this);

    this.state = {
      tab: (this.props.location||{}).pathname
    };
  }

  changeTab(value) {
    this.setState({tab: value});

    this.props.history.push(value);
  }

  render() {
    const { className } = this.props;
    const h2Icon = {
      marginLeft: 24,
      marginRight: 24,
    };
    /*const uiTheme = {
      primaryColor: '#607d8b',
      primaryLightColor: '#8eacbb',
      primaryDarkColor: '#34515e',
      secondaryColor: '#448aff',
      secondaryLightColor: '#83b9ff',
      secondaryDarkColor: '#005ecb',
      primaryTextColor: '#ffffff',
      secondaryTextColor: '#ffffff',
    };*/

    return (
      <div className={classnames('container', className)}>
        <GridList
          cols={3}
          padding={10}
          cellHeight='auto'
        >
          <GridTile
            /* title = "Jefferson Seide Molléri, M.Sc."
            subtitle = "Doctorand / PhD Student"
            titlePosition = "top" */
            className={classnames('col l4 m12 s12 sidebar z-depth-1')}
          >
            <div className={classnames('heading')}>
              <div className={classnames('feature-img')}>
                <img src="/img/profile-img.JPG" width="100%" className={classnames('responsive-img')} alt="" />
              </div>
              <div className={classnames('title col s12 m12 l9')}>
                <h2>Jefferson Seide Molléri</h2>
                <span>Postdoctoral Fellow</span>
              </div>
            </div>
			<List className={classnames('sidebar', className)}>
              <ListItem
                leftAvatar={<Avatar icon={<Mail />} backgroundColor='rgba(0,0,0,0)' />}
                primaryText={<a href="mailto:jefferson.molleri@gmail.com">jefferson.molleri@gmail.com</a>}
                secondaryText="e-mail"
                disabled="true"
              />
              <Divider inset={true} />
              <ListItem
                leftAvatar={<Avatar icon={<Phone />} backgroundColor='rgba(0,0,0,0)' />}
                primaryText="+47 4021 2262"
                secondaryText="mobile"
                disabled="true"

              />
              <Divider inset={true} />
              <ListItem
                leftAvatar={<Avatar icon={<Address />} backgroundColor='rgba(0,0,0,0)' />}
                primaryText={<span>Simula Metropolitan<br />IT Management<br /></span>}
                secondaryText={<span>Pilestredet 52<br />0167 Oslo, Norway</span>}
                disabled="true"
              />
            </List>
          </GridTile>
          <GridTile cols="2">
            <Card>
              <CardTitle title="PhD Dissertation" />
              <CardText>
				<h2><strong>Views of Research Quality in Empirical Software Engineering</strong></h2>
			  
			    <h3>Overview:</h3>
				
				<p><b>Background.</b> Software Engineering (SE) research, like other applied disciplines, intends to provide trustful evidence to practice. To ensure trustful evidence, a rigorous research process based on sound research methodologies is required. Further, to be practically relevant, researchers rely on identifying original research problems that are of interest to industry; and the research must fulfill various quality standards that form the basis for the evaluation of the empirical research in SE. A dialogue and shared view of quality standards for research practice is still to be achieved within the research community.</p>
				<p><b>Objectives.</b> The main objective of this thesis is to foster dialogue and capture different views of SE researchers on method level (e.g., through the identification and reasoning on the importance of quality characteristics for experiments, surveys and case studies) as well as general quality standards for Empirical Software Engineering (ESE). Given the views of research quality, a second objective is to understand how to operationalize, i.e. build and validate instruments to assess research quality.</p>
				<p><b>Method.</b> The thesis makes use of a mixed method approach of both qualitative and quantitative nature. The research methods used were case studies, surveys, and focus groups. A range of data collection methods has been employed, such as literature review, questionnaires, and semi-structured workshops. To analyze the data, we utilized content and thematic analysis, descriptive and inferential statistics.</p>
				<p><b>Results.</b> We draw two distinct views of research quality. Through a top-down approach, we assessed and evolved a conceptual model of research quality within the ESE research community. Through a bottom-up approach, we built a checklist instrument for assess survey-based research grounded on supporting literature and evaluated ours and others’ checklists in research practice and research education contexts.</p>
				<p><b>Conclusion.</b> The quality standards we identified and operationalized support and extend the current understanding of research quality for SE research. This is a preliminary, but still vital, step towards a shared understanding and view of research quality for ESE research. Further steps are needed to gain a shared understanding of research quality within the community.</p>
				
				<h2>Thesis Chapters</h2>
				
				<List>
				    <ListItem
					  primaryText={<span class="paragraph"><strong>Chapter 1: Introduction</strong><br/><small>Status: only editorial changes [<a href="https://www.dropbox.com/s/6ainxjuu2foa0gp/ch1.pdf?dl=0">chapter 1</a>]</small></span>}
					  disabled="true"
					  insetChildren="true"
				    />
				    <Divider inset={true} />
				    <ListItem
					  primaryText={<span class="paragraph"><strong>Chapter 2: Towards understanding the relation between citations and research quality in software engineering studies</strong><br /><small>Jefferson Seide Molléri, Kai Petersen and Emilia Mendes. <q>Towards understanding the relation between citations and research quality in software engineering studies.</q> <em>Scientometrics</em> 117(3): 1453-1478, (2018).<br/>Status: only editorial changes [<a href="https://www.dropbox.com/s/omh7xt8ks6ptu2n/ch2.pdf?dl=0">chapter 2</a>]</small></span>}
					  disabled="true"
					  insetChildren="true"
				    />
				    <Divider inset={true} />
				    <ListItem
					  primaryText={<span class="paragraph"><strong>Chapter 3: A Catalog for empirical research in software engineering</strong><br /><small>Jefferson Seide Molléri, Kai Petersen and Emilia Mendes. <q>CERSE-Catalog for empirical research in software engineering: A Systematic mapping study.</q> <em>Information and Software Technology</em> 105: 117-149, 2019.<br/>Status: only editorial changes  only editorial changes [<a href="https://www.dropbox.com/s/rm3x6qrbaay879q/ch3.pdf?dl=0">chapter 3</a> | <a href="https://www.dropbox.com/s/8qeyws0u2xb2kfi/ch3-app.pdf?dl=0">appendices</a>]</small></span>}
					  disabled="true"
					  insetChildren="true"
				    />
				    <Divider inset={true} />
				    <ListItem
					  primaryText={<span class="paragraph"><strong>Chapter 4: Views of Importance of Quality in Empirical Software Engineering Research</strong><br /><small>Jefferson Seide Molléri, Michael Felderer, Kai Petersen and Emilia Mendes. <q>Views of Importance of Quality in Empirical Software Engineering Research.</q> Submitted to <em>ACM Transactions on Software Engineering and Methodology</em>.<br/>Status: only editorial changes [<a href="https://www.dropbox.com/s/6cv1iot2efpsdc4/ch4.pdf?dl=0">chapter 4</a>]</small></span>}
					  disabled="true"
					  insetChildren="true"
				    />
				    <Divider inset={true} />
				    <ListItem
					  primaryText={<span class="paragraph"><strong>Chapter 5: Teaching Students Critical Appraisal of Scientific Literature using Checklists</strong><br /><small>Jefferson Seide Molléri, Molléri, Jefferson Seide, Nauman bin Ali, Kai Petersen, Nasir Mehmood Minhas, and Panagiota Chatzipetrou. <q>Teaching students critical appraisal of scientific literature using checklists.</q> In <em>Proceedings of the 3rd European Conference of Software Engineering Education</em>, pp. 8-17. ACM, 2018.<br/>Status: only editorial changes  only editorial changes [<a href="https://www.dropbox.com/s/48zydoja923jvlo/ch5.pdf?dl=0">chapter 5</a>]</small></span>}
					  disabled="true"
					  insetChildren="true"
				    />
				    <Divider inset={true} />
				    <ListItem
					  primaryText={<span class="paragraph"><strong>Chapter 6: An Empirically Evaluated Checklist for Surveys in Software Engineering</strong><br /><small>Jefferson Seide Molléri, Kai Petersen and Emilia Mendes. <q>An Empirically Evaluated Checklist for Surveys in Software Engineering.</q> <em>Information and Software Technology</em> 119:106240, 2020.<br/>Status: only editorial changes  only editorial changes [<a href="https://www.dropbox.com/s/nkmj76go3piqs69/ch6.pdf?dl=0">chapter 6</a>]</small></span>}
					  disabled="true"
					  insetChildren="true"
				    />
				  </List>
              </CardText>
            </Card>
          </GridTile>
        </GridList>
      </div>
    );
  }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/Thesis/index.js